<script lang="ts">
  import * as utils from "@/utils/helpers/utils";
  import config from "@/config";
  import profileStore from "@/stores/profile";
  import trackEvents from "@/events";
  import clsx from "clsx";

  const { downloadAppUrl }: { downloadAppUrl: string } = config;

  export let label = "Install Now",
    intentUrl = "",
    referrer = "",
    style = "",
    source = "",
    imageSrc = "",
    imageSrcSet = "";
  let isAppIntentSupported = utils.isAndroid();

  const handleInstall = () => {
    trackEvents("DownloadAppButton", {
      source,
    });
  };
</script>

<div
  class={clsx(
    !imageSrc && style,
    !imageSrc &&
      !style &&
      "rounded-lg bg-brand-yellow text-black px-2 py-[5px] cursor-pointer"
  )}
  on:mouseup={handleInstall}
>
  <a
    href={isAppIntentSupported
      ? `${utils.ANDROID_APP_INTENT(
          intentUrl,
          `${$profileStore.userId}_${referrer}`,
          $profileStore.deviceId
        )}`
      : downloadAppUrl}
    target={isAppIntentSupported ? "" : "_blank"}
  >
    {#if imageSrc}
      <img class="h-12" src={imageSrc} srcset={imageSrcSet} alt="install" />
    {:else}
      {label}
    {/if}
  </a>
</div>
